import { useState, useEffect } from "react";

export const MOBILE_BREAKPOINT = 768;

export function useIsMobile(maxWidth = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= maxWidth : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= maxWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [maxWidth]);

  return isMobile;
}

export const merge = (base, override, when) => (when ? { ...base, ...override } : base);
